import { userUsesSelfElectedPublicFundingOptions } from "@outschool/funding-programs-shared";
import { useSession } from "@outschool/ui-auth";

export function useIsEligibleFor40PercentCouponUpsell() {
  const { isLoggedIn, currentUser, isEsaSession } = useSession();
  const selfElectedStateFundingProgram =
    currentUser?.selfElectedStateFundingProgram;

  const isExistingALaCarteBuyer = !!currentUser?.firstPaidEnrollment;

  // Audience for 40 percent coupon:
  // logged in users who have purchased a la carte classes, but do not have a membership (or any credits)
  // and are not ESA users or users in excluded states and the user does not use a self-elected public funding option
  // (i.e. charters should not see a membership modal)
  const isEligibleFor40PercentCouponUpsell =
    isLoggedIn &&
    isExistingALaCarteBuyer &&
    !currentUser?.hasSubscription &&
    !currentUser?.canPayWithSubscriptionCredits &&
    !isEsaSession &&
    !currentUser?.hasEsaMembership &&
    !userUsesSelfElectedPublicFundingOptions(selfElectedStateFundingProgram);

  return {
    isEligibleFor40PercentCouponUpsell
  };
}
